import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b723d70"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "本次活动中奖记录")
], -1))
const _hoisted_2 = { class: "raffle-record-card-body" }

import { onMounted, ref } from 'vue'
import SeamlessScroll from '../components/SeamlessScroll.vue'
import { getListData } from '@/service/main/system'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { ElLoading } from 'element-plus'

interface Prize {
  id: number
  deptName: string
  empName: string
  amount: number
  raffleType: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RaffleRecord',
  setup(__props) {

const items = ref<Prize[]>([])

const prizes = ref<Prize[]>([])

const dataList = ref([])
let loadingInstance: ILoadingInstance = {} as ILoadingInstance
const getData = () => {
  // loadingInstance = ElLoading.service({
  //   target: '.raffle-record-card-body'
  // })
  getListData('/main/raffleRecord/listRecords', {}).then((res) => {
    // if (loadingInstance) {
    //   loadingInstance.close()
    // }
    dataList.value = res
    console.log(res)
    if (dataList.value && dataList.value.length > 0) {
      prizes.value = dataList.value.filter((item: any) => item.raffleType == 0)
      items.value = dataList.value.filter((item: any) => item.raffleType == 1)
    } else {
      prizes.value = []
      items.value = []
    }
  })
}

onMounted(() => {
  getData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SeamlessScroll, {
          onRefresh: getData,
          options: { prizes: prizes.value, items: items.value }
        }, null, 8, ["options"])
      ])
    ]),
    _: 1
  }))
}
}

})